import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../components/common/Card';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { roundsAPI } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

export default function Scoring() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [loading, setLoading] = useState(true);
  const [activeRound, setActiveRound] = useState(null);

  useEffect(() => {
    fetchActiveRound();
  }, []);

  const fetchActiveRound = async () => {
    try {
      setLoading(true);
      const round = await roundsAPI.getActive();
      if (round && round.id) {
        // Show active round - redirect to scoring interface
        navigate(`/rounds/${round.id}`, { state: { activeTab: 'enter-scores' }, replace: true });
      } else {
        setActiveRound(null);
      }
    } catch (err) {
      console.error('Failed to fetch active round:', err);
      setActiveRound(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div>
      {/* No Active Round Message */}
      <div className="px-4">
        <Card>
          <div className="text-center py-12">
            <div className="text-6xl mb-4">📝</div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">No Active Round</h2>
            <p className="text-lg text-gray-600 mb-4">
              Score entry is only available during live rounds.
            </p>
            <p className="text-base text-gray-600 mb-6">
              {isAuthenticated
                ? 'Start a round from the Events page to begin entering scores.'
                : 'An admin needs to start a round before scoring can begin.'}
            </p>
            {isAuthenticated && (
              <button
                onClick={() => navigate('/events')}
                className="px-6 py-3 bg-primary text-white font-semibold rounded-lg hover:bg-secondary transition-colors"
              >
                Go to Events
              </button>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
}
